

import * as THREE from "three";


export const  MDRVideoPoints = [
	{
		Id: 'VideoPoint_NHM',
		Titel: 'NHM Wien',
		TitelEn: 'NHM Wien',
		Position: new THREE.Vector3 (396.166, 6.01844e-06, 226.089),
		Rotation: new THREE.Vector3 (0.0,0.0,180),
		Url: "https://www.youtube.com/embed/TbjoBxCSE0s?rel=0&autoplay=1&amp&;controls=0",
		UrlEn: "https://www.youtube.com/embed/zm1GO8ArntI?rel=0&autoplay=1&amp&;controls=0",
		AreaSquareA: 65,
		AreaSquareB: 35,
		AdjustCheckPosition: 20,
	},

	{
		Id: 'SalineAustriaAG',
		Titel: 'Saline Austria AG',
		TitelEn: 'Saline Austria AG',
		Position: new THREE.Vector3 (595.627, 6.01844e-06, 226.089),
		Rotation: new THREE.Vector3 (0.0,0.0,180),
		Url: "https://www.youtube.com/embed/l7gESL9Bm98?rel=0&autoplay=1&amp&;controls=0",
		UrlEn: "https://www.youtube.com/embed/l7gESL9Bm98?rel=0&autoplay=1&amp&;controls=0",
		AreaSquareA: 65,
		AreaSquareB: 35,
		AdjustCheckPosition: 20,
	},

	{
		Id: 'VideoPoint_OOE',
		Titel: 'OÖ Landes-Kultur GmbH',
		TitelEn: 'OÖ Landes-Kultur GmbH',
		Position: new THREE.Vector3 (413.068, 6.01844e-06, -226.639),
		Rotation: new THREE.Vector3 (0.0,0.0,0),
		Url: "https://www.youtube.com/embed/g0bdS6-8Bgk?rel=0&autoplay=1&amp&;controls=0",
		UrlEn: "https://www.youtube.com/embed/g0bdS6-8Bgk?rel=0&autoplay=1&amp&;controls=0",
		AreaSquareA: 65,
		AreaSquareB: 35,
		AdjustCheckPosition: 20,
	},

	{
		Id: 'VideoPoint_Welterberegion',
		Titel: 'Unesco Welterberegion',
		TitelEn: 'Unesco Welterberegion',
		Position: new THREE.Vector3 (584.499, 6.01844e-06, -226.639),
		Rotation: new THREE.Vector3 (0.0,0.0,0),
		Url: "https://www.youtube.com/embed/FAunJ7k9HmU?rel=0&autoplay=1&amp&;controls=0",
		UrlEn: "https://www.youtube.com/embed/FAunJ7k9HmU?rel=0&autoplay=1&amp&;controls=0",
		AreaSquareA: 65,
		AreaSquareB: 35,
		AdjustCheckPosition: 20,
	},
	
];